// formatDate.js - Shared date formatting utility
// Standard US date format: MM.DD.YYYY

/**
 * Format a date to US format: MM.DD.YYYY
 * @param {string|Date} date - Date string or Date object
 * @returns {string} Formatted date string (e.g., "02.12.2026")
 */
export const formatDateUS = (date) => {
  if (!date) return '';
  try {
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return '';
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}.${dd}.${yyyy}`;
  } catch {
    return '';
  }
};

/**
 * Format a date to US format with time: MM.DD.YYYY HH:mm:ss
 * @param {string|Date} date - Date string or Date object
 * @returns {string} Formatted datetime string (e.g., "02.12.2026 14:30:05")
 */
export const formatDateTimeUS = (date) => {
  if (!date) return '-';
  try {
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return '-';
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');
    return `${mm}.${dd}.${yyyy} ${hh}:${min}:${ss}`;
  } catch {
    return '-';
  }
};
